module.exports = __webpack_public_path__ + "assets/media/error.fd86ebaa.mp3";